import {createFileRoute, stripSearchParams} from '@tanstack/react-router'
import {type} from 'arktype'

import guestRoute from '@/auth/middleware/guestRoute'
import searchParamString from '@/utils/schema/searchParamString'

const DEFAULT_VALUES = {
  referrerId: '',
  redirect: '',
}

const resetPasswordSearchSchema = type({
  referrerId: searchParamString.default(DEFAULT_VALUES.referrerId),
  redirect: searchParamString.default(DEFAULT_VALUES.redirect),
})

export const Route = createFileRoute('/auth/sign-in-with-google/$idToken')({
  validateSearch: resetPasswordSearchSchema,
  search: {
    middlewares: [stripSearchParams(DEFAULT_VALUES)],
  },
  beforeLoad: ({context, search}) => {
    guestRoute(context.store, search.redirect)
  },
})
